@use '@lib/assets/styles/main.scss' as *;
.filterWrap {
  margin: 0 -12px 8px;
}

.filter {
  padding: 8px 8px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.filterRow {
  display: flex;
  align-items: center;
  & > div {
    padding: 0 4px;
    &.clearBtnCol {
      padding-left: 0;
    }
  }
}

.sortingRow {
  padding: 0 4px;
}

.sortingBtn {
  display: block;
}
